export enum AnalyticsEvent {
  PEOPLE_EXPORTED = "people_exported",
  APPLICATIONS_EXPORTED = "applications_exported",
  REWAVING_SAVED = "rewaving_saved",
}
